export const backgroundColorCounter = {
    backgroundColor: '#ECFAFB'
}
export const marginTop80 = {marginTop: '-80px'}

export const cursorPointer = {
    cursor: "pointer"
}

export const swapperGallery = {
    transitionDuration: '0ms', 
    transform: 'translate3d(-310px, 0px, 0px)'
}

export const swapperRoom = {
    transform: 'translate3d(0px, 0px, 0px)'
}

export const slideGallery = {
    width: '600px',
    marginRight: '20px'
}

export const slideRoom = {
    width: '393.333px',
    marginRight: '20px'
}

export const spaceBetween = {
    display: 'flex',
    justifyContent: 'space-between'
}

export const marginLarge = {
    maxWidth : '1700px',
    margin: '0px auto'
}
export const borderO = {
    border : '0'
}